export const createPermissionStatusDictionary = permissionRequests => {
    return permissionRequests.reduce((acc, curr) => { 
        return{
            ...acc,
            [curr["imageId"]]: curr["status"]
        }
    }, {});

};